import { useState, useEffect, useCallback } from "react";
import {
  load_storage,
  remove_storage,
  save_storage,
} from "../utils/localstorage";
// update the path

export function useLocalStorage(key, initialValue = {}) {
  const [storedValue, setStoredValue] = useState(() => {
    const item = load_storage(key);
    return item !== null ? item : initialValue;
  });

  // Set value and save to localStorage
  const setValue = useCallback(
    (value) => {
      setStoredValue((prev) => {
        const valueToStore = value instanceof Function ? value(prev) : value;
        save_storage(key, valueToStore);
        return valueToStore;
      });
    },
    [key]
  );

  // Remove key from localStorage and reset to initialValue
  const remove = useCallback(() => {
    remove_storage(key);
    setStoredValue(initialValue);
  }, [key, initialValue]);

  // Sync with changes in localStorage (from other tabs)
  useEffect(() => {
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === key) {
        const newValue = event.newValue
          ? JSON.parse(event.newValue)
          : initialValue;
        setStoredValue(newValue);
      }
    };
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, [key, initialValue]);

  return [storedValue, setValue, remove];
}

export function useLocalState(key, initialValue = {}) {
  return useLocalStorage(key, initialValue);
}
